<template>
   <v-container>
     <div itemscope itemtype="http://schema.org/Service">
       <meta itemprop="serviceType" content="Rechenzentrum" />
     <v-layout row wrap>
       <v-flex xs12>
         <v-card>
           <div itemprop="image">
           <v-card-media
             class="edomargintop"
             alt="rechenzentrum"
             height="450px"
             :src="require('../assets/rechenzentrum.jpg')">
             <v-container fill-height>
               <v-layout fill-height>
                 <v-flex xs12 align-end flexbox positionsofteware>
                   <div itemprop="name">
                   <span class="edoheadlinerechen">AUTHENTISCHES RECHENZENTRUM</span>
                   </div>
                 </v-flex>
               </v-layout>
             </v-container>
           </v-card-media>
           </div>
         </v-card>
       </v-flex>
       <div>
         <v-breadcrumbs divider=">" class="edobread">
           <v-breadcrumbs-item
             v-for="item in items"
             :key="item.text"
             :disabled="item.disabled"
           >
             <a :href='item.route'>{{ item.text }}</a>
           </v-breadcrumbs-item>
         </v-breadcrumbs>
       </div>
     </v-layout>
       <v-container fluid grid-list-md>
         <v-layout row justify-space-around>
           <v-flex d-flex xs12 sm8 md8>
             <v-card class="edomargintop" flat>
               <v-card-text class="edoLineText">
                 <span itemprop="description">
                 Datenintegrität – ein Indikator für Geborgenheit.
                 <br><br>
                 Um Ihnen das Gefühl der Geborgenheit zu ermöglichen, bietet Ihnen die edologic innovative Dienstleistungen in einem Rechenzentrum mit idealem Standort in Düsseldorf an.
                 <br>
                 Die Positionierung des Rechenzentrums bietet den Vorteil, dass Ihre Daten dem deutschen Datenschutz unterliegen.
                 Die eigene Infrastruktur ermöglicht es, Ihnen eine geringe Ausfallwahrscheinlichkeit zu bieten und die Störfälligkeit auf ein Minimum herabzusetzen.
                 </span>
               </v-card-text>
             </v-card>
           </v-flex>
         </v-layout>
       </v-container>

     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm8 md8>
           <v-card class="edomargintop" flat>
             <v-card-text class="edoLineText">
               <span itemprop="description">
               Darüber hinaus hält das Rechenzentrum noch viele weitere Vorteile für Sie bereit:
               <br><br>
               • ISO 27001 Zertifizierung<br>
               • Tier 3 Standard<br>
               • 24/7 Betriebsüberwachung mit Weiterleitung an Techniker<br>
               • 24/7 Videoüberwachung des kompletten Geländes und der Gebäude<br>
               • 24/7 Objektüberwachung durch einen Sicherheitsdienstes<br>
               • hohe Brandschutz-Maßnahmen<br>
               • u.v.m.
               </span>
             </v-card-text>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm8 md8>
           <v-card class="edomargintop" flat>
             <v-card-text class="edoLineText">
               <span itemprop="description">
               Wir freuen uns Ihnen folgende Dienstleistungen durch das Rechenzentrum anbieten zu können:
               <br><br>
               • Webhosting<br>
               • Dedicated Server<br>
               • E-Mail Dienste<br>
               • Monitoring<br>
               • Backup - Lösungen (Owncloud/ Nextcloud)<br>
               • Contao Hosting<br>
               • u.v.m.
               <br><br>
               Sprechen Sie uns an, wir unterstützen Sie!
               </span>
             </v-card-text>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>
     </div>

     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm9 md9>
           <v-card class="edomargintop" flat>
             <div itemprop="email" itemscope itemtype="http://schema.org/PostalAddress">
             <div class="text-xs-center edomargintop linkedo">
               <v-btn outline color="grey darken-3" @click="mailto">
                 <a href="mailto:info@edologic.de" itemprop="email">
                 Mehr Informationen per Mail erhalten
                 </a>
               </v-btn>
             </div>
             </div>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>
     <v-layout row wrap>
       <v-container>
         <v-card class="edoabstandfooter" flat>
         </v-card>
       </v-container>
     </v-layout>
     </v-container>
</template>

<script>

  export default {
    components: {},
    name: 'Rechenzentrum',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Rechenzentrum – innovative Dienstleistungen an einem Ort',
      meta: [
        {
          name: 'description',
          content: 'Stabilität, Sicherheit, hohe Verfügbarkeit, schnelle Performance – das sind nur einige Punkte die das Rechenzentrum beschreiben.'
        }]
    },
    data: () => ({
      items: [
        {
          text: 'Home',
          route: '/home',
          disabled: false
        },
        {
          text: 'Service',
          route: '/service',
          disabled: false
        },
        {
          text: 'Rechenzentrum',
          route: '',
          disabled: true
        }
      ]
    }),
    methods: {
      mailto () {
        window.location = 'mailto:info@edologic.de'
      }
    },
    mounted () {
      console.log('Rechenzentrum')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Rechenzentrum.vue